export default __webpack_public_path__ + "static/media/person_1@2x.0c9e7460.png";